export const getAssetUrl = (path: string) => {
  const imageServer = process.env.VUE_APP_IMAGE_PATH;
  return `${imageServer}${path}`;
}